module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "tab-selector"
  }, _vm._l((_vm.tabsData), function(tab, key) {
    return _c('li', {
      staticClass: "tab-selector-item"
    }, [_c('button', {
      ref: "tab-button",
      refInFor: true,
      staticClass: "tab-button",
      class: {
        first: key === 0, last: key === _vm.lastIndex, active: key === _vm.activeIndex
      },
      attrs: {
        "type": "button",
        "name": tab.id
      },
      on: {
        "click": function($event) {
          _vm.changeActive(tab.id, key)
        }
      }
    }, [_vm._v("\n      " + _vm._s(tab.label)), (tab.counter) ? _c('number-icon', {
      attrs: {
        "value": tab.counter
      }
    }) : _vm._e()], 1)])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1bf6a9ce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TabSelector.vue
// module id = 292
// module chunks = 2